<template>
  <div class="w-12 h-12 rounded-full  flex items-center justify-center relative overflow-hidden ">
    <img class="" :src="img" :alt="name" v-if="img" />
    <span class=" bg-gradient-to-b from-blue-start to-blue-end w-full h-full rounded-full text-white font-black flex items-center justify-center" >
      <img src="/img/menu/profile.svg" :alt="name" />
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["user"]),
    img: function() {
      return this.user?.photoURL;
    },
    name: function() {
      return this.user?.displayName;
    }
  },
};
</script>

<style>

</style>
